import React, { useState, useEffect, useRef } from "react";

const SmallDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const ref = useRef();

  useEffect(() => setInputValue(value || ""), [value]);
  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const parseDDMMYYYY = (s) => {
    const parts = String(s).split("/");
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts.map((p) => parseInt(p, 10));
      if (!isNaN(dd) && !isNaN(mm) && !isNaN(yyyy))
        return new Date(yyyy, mm - 1, dd);
    }
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  };

  const formatDDMMYYYY = (d) => {
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const handlePick = (d) => {
    const val = formatDDMMYYYY(d);
    setInputValue(val);
    onChange(val);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <div className="flex items-center space-x-2">
        <input
          type="text"
          placeholder="dd/mm/yyyy"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() => {
            const parsed = parseDDMMYYYY(inputValue);
            if (parsed) onChange(formatDDMMYYYY(parsed));
          }}
          className="p-2 border rounded-md w-40"
        />
        <button
          type="button"
          onClick={() => setOpen((s) => !s)}
          className="p-2 bg-yellow-100 rounded border"
        >
          📅
        </button>
      </div>
      {open && (
        <div className="absolute z-40 mt-2 bg-white border rounded shadow p-2">
          <input
            type="date"
            className="p-2 border rounded"
            onChange={(e) => {
              const d = new Date(e.target.value);
              if (!isNaN(d.getTime())) handlePick(d);
            }}
          />
          <div className="mt-2 text-xs text-gray-500">
            Pick a date or type dd/mm/yyyy
          </div>
        </div>
      )}
    </div>
  );
};

export default SmallDatePicker;
